/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import { createTheme } from '@mui/material/styles';
import pearsonTheme from '@greenville/mui-theme';
import mixins from '../../assets/styles/mixins.scss';

const muiTheme = createTheme(pearsonTheme, {
  typography: {
    fontFamily: mixins.fontFamilyOpenSans,
    h6: {
      fontSize: mixins.fontSize14,
      fontFamily: mixins.fontFamilyOpenSans,
      fontWeight: mixins.fontWeight600,
      lineHeight: 1.58
    },
    body2: {
      fontSize: mixins.fontSize14,
      fontFamily: mixins.fontFamilyOpenSans,
      fontWeight: mixins.fontWeight400,
      lineHeight: mixins.lineHeight143
    },
    body1: {
      fontSize: mixins.fontSize14,
      fontFamily: mixins.fontFamilyPlusSans,
      fontWeight: mixins.fontWeight400,
      lineHeight: mixins.lineHeight143
    }
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
        disableTouchRipple: true
      },
      styleOverrides: {
        root: {
          '& .MuiTouchRipple-root': {
            display: 'none'
          }
        }
      }
    },
    MuiButton: {
      defaultProps: {
        disableRipple: true,
        disableTouchRipple: true
      },
      styleOverrides: {
        root: {
          border: '2px solid rgba(0, 0, 0, 0)',
          color: mixins.navyColor,
          '&.aet-button-card': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            justifyContent: 'flex-start',
            textAlign: 'left',
            textTransform: 'none',
            width: '100%',
            minWidth: 'unset',
            maxWidth: 'none',
            height: 'auto',
            padding: 16,
            color: 'inherit',
            lineHeight: 'inherit',
            fontWeight: 'inherit',
            fontFamily: 'inherit',
            border: 'none',
            boxShadow: 'none',
            gap: 16,
            backgroundColor: 'var(--card-bg)',
            background: 'var(--card-bg)',
            '&:hover': {
              color: 'inherit',
              backgroundColor: 'var(--card-bg)',
              background: 'var(--card-bg)'
            }
          },
          '&.MuiButton-text': {
            color: mixins.navyColor,
            background: 'transparent',
            backgroundColor: 'transparent',
            '&:hover': {
              color: mixins.navyColor,
              background: 'transparent',
              backgroundColor: 'transparent'
            }
          },
          '&.MuiButton-text.aet-button-card': {
            color: 'inherit',
            backgroundColor: 'var(--card-bg)',
            background: 'var(--card-bg)',
            '&:hover': {
              color: 'inherit',
              backgroundColor: 'var(--card-bg)',
              background: 'var(--card-bg)'
            }
          }
        },
        text: {
          background: 'transparent',
          backgroundColor: 'transparent',
          '&:hover': {
            background: 'transparent',
            backgroundColor: 'transparent'
          }
        },
        textPrimary: {
          color: mixins.navyColor,
          '&:hover': {
            color: mixins.navyColor,
            background: 'transparent',
            backgroundColor: 'transparent'
          }
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          opacity: 0.7,
          '&.Mui-selected': {
            color: 'inherit',
            opacity: 1
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          minHeight: 'unset',
          boxShadow: 'none',
          '--Paper-shadow': 'none'
        }
      }
    },
    MuiSvgIcon: {
      defaultProps: {
        fontSize: 'inherit'
      },
      styleOverrides: {
        root: {
          fontSize: 'inherit'
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: mixins.fontFamilyPlusSans
        },
        body1: {
          fontFamily: mixins.fontFamilyPlusSans,
          fontSize: mixins.fontSize14,
          fontWeight: mixins.fontWeight400,
          lineHeight: mixins.lineHeight143
        }
      }
    }
  }
});

export default muiTheme;
